import { apiProxyRequest } from "Api/apiProxyRequest";

export interface TrialResourceLimit {
  projects: number;
  environments: number;
  cpu: number;
  memory: number;
  storage: number;
}

export interface OrganizationTrial {
  status: string;
  model: string;
  created_at: string;
  updated_at: string;
  organization_id: string;
  billing_account_id: string | null;
  expiration: string;
  days_remaining: number;
  resource_limit: TrialResourceLimit;
}

export interface TrialResponse {
  trial: OrganizationTrial;
}

export const getTrialRequest = (organizationId: string) =>
  apiProxyRequest<TrialResponse>(`/organizations/${organizationId}/trial`);
